import './assets/main.scss';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import VueApexCharts from 'vue3-apexcharts';

import VueCookies from 'vue-cookies';

import App from './App.vue';
import router from './router';
import * as Sentry from '@sentry/vue';

const app = createApp(App);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_MODE, // This will be 'production' or 'staging' based on the build mode
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api\.meshh\.com/,
    /^http:\/\/api\.meshh\.127\.0\.0\.1\.nip\.io/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// print the dsn and the mode to the console
console.log('Sentry DSN:', import.meta.env.VITE_APP_SENTRY_DSN);
console.log('Mode:', import.meta.env.VITE_APP_MODE);

app
  .use(createPinia())
  .use(router)
  .use(VueCookies)
  .use(VueApexCharts);

const RELOAD_KEY = 'vite-preload-reload-time';
const COOLDOWN_MS = 30000; // 30 seconds

window.addEventListener('vite:preloadError', () => {
  const lastReload = sessionStorage.getItem(RELOAD_KEY);
  const now = Date.now();

  if (lastReload && (now - parseInt(lastReload, 10)) < COOLDOWN_MS) {
    console.error('Chunk load failed again within cooldown period. Giving up to avoid loop.');
    return;
  }

  // Set the current time before reloading
  sessionStorage.setItem(RELOAD_KEY, now.toString());
  console.warn('New deployment detected, reloading page...');
  window.location.reload();
});


app.mount('#app');
